import { VectorLayerService } from '@nuxtDatakodeUtils/services/vectorLayer.service'
import type { FeatureLike } from 'ol/Feature'
import { Stroke, Style } from 'ol/style'

type IntentionData = PildomModules.Voirie.Data.IntentionData

// noinspection JSUnusedGlobalSymbols
export class IntentionVectorLayerService extends VectorLayerService {
    // noinspection JSUnusedGlobalSymbols
    protected override highlightOnlyFirst = true // highlight only one feature

    protected fillHighLightedColor: string = '#ff5100ff'
    protected strokeHighLightedColor: string = '#ff5100ff'

    protected fillSelectedColor: string = '#0095ff'
    protected strokeSelectedColor: string = '#0095ff'
    protected editColor = '#0098ff'

    override getLineStringStyle(feature: FeatureLike, isHighLighted: boolean, isSelected: boolean): Style {
        const properties: IntentionData = feature.getProperties() as IntentionData
        const dueStatus = properties.due_status
        const color = dueStatus ? this.getDueStatusColor(properties.due_status) : '#0000ff'
        return new Style({
            stroke: new Stroke({
                color: isSelected ? '#0000ff' : color,
                width: isHighLighted || isSelected ? 7 : 5,
            }),
        })
    }

    getDueStatusColor(due_status: string | null): string {
        switch (due_status) {
            case 'd1':
                return '#b00e1e'
            case 'd2':
                return '#ff2600'
            case 'd3':
                return '#ff8801'
            default:
                console.error(`Unhandled due_status style: ${due_status}`)
                return '#ff0000'
        }
    }

    override getEditedLineStringStyle(feature: FeatureLike, isHighLighted: boolean): Style {
        const res = this.getLineStringStyle(feature, isHighLighted, false)
        res.setStroke(new Stroke({
            color: '#0098ff', // '#0098ff'
            width: 5,
        }))
        return res
    }
}
